/* eslint-disable @typescript-eslint/no-magic-numbers */
import React, { FC } from 'react';
import { Col, Row, Typography } from 'antd';
import styles from './styles.less';

export const InterestsTips: FC = () => (
  <div className={styles['interests-tips']}>
    <Row>
      <Col span={24} lg={{ span: 12 }}>
        <Typography>Examples for hobbies to list:</Typography>
        <Row>
          <Col span={24} xl={{ span: 12 }}>
            <ul>
              <li>Artistic activities such as painting or graphic design</li>
              <li>Community service</li>
              <li>Cooking or baking</li>
              <li>Exercising and healthcare</li>
              <li>Outdoor activities</li>
            </ul>
          </Col>
          <Col span={24} xl={{ span: 12 }}>
            <ul>
              <li>Playing an instrument</li>
              <li>Team or individual sports</li>
              <li>Travel Woodworking or other projects</li>
              <li>Writing or blogging</li>
            </ul>
          </Col>
        </Row>
      </Col>
      <Col span={24} lg={{ span: 12 }}>
        <Typography>Examples for interests to list:</Typography>
        <Row>
          <Col span={24} xl={{ span: 12 }}>
            <ul>
              <li>Making or listening to music</li>
              <li>Gaming</li>
              <li>Travel</li>
              <li>Art</li>
              <li>Nature</li>
            </ul>
          </Col>
          <Col span={24} xl={{ span: 12 }}>
            <ul>
              <li>Social causes</li>
              <li>Foreign languages</li>
              <li>Topical blogs or research</li>
              <li>History</li>
              <li>Theater</li>
            </ul>
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
);
